import { createRouter, createWebHistory } from 'vue-router'; // createRouter ve createWebHistory içe aktarın
import MainDashboard from '../views/MainDashboard.vue'; // Ana görünüm
import UserLogin from '../views/UserLogin.vue'; // Login görünümü
import UserRegister from '../views/UserRegister.vue'; // Login görünümü
import PhoneDashboard from '../views/PhoneDashboard.vue'; // Login görünümü
import UserList from '../views/User/UserList.vue'; // Login görünümü
import SellerList from '../views/Seller/SellerList.vue'; // Login görünümü
import CustomerList from '../views/Customer/CustomerList.vue'; // Login görünümü
import BrandList from '../views/Common/BrandList.vue'; // Login görünümü
import ColorList from '../views/Common/ColorList.vue'; // Login görünümü
import StockList from '../views/Stock/StockList.vue'; // Login görünümü
import InvoiceList from '../views/Invoice/InvoiceList.vue'; // Login görünümü
import CategoryList from '../views/Category/CategoryList.vue'; // Login görünümü
import PhoneList from '../views/Phone/PhoneList.vue'; // Login görünümü
import SerialNumberList from '../views/SerialNumber/SerialNumberList.vue'; // Login görünümü
import PhoneCreate from '@/views/Phone/PhoneCreate.vue'  // Import the component
import TransferList from '@/views/Transfer/TransferList.vue'  // Import the component
import SaleList from '@/views/Sale/SaleList.vue'  // Import the component
import TechnicalServiceList from '@/views/Sale/TechnicalServiceList.vue'  // Import the component
import NewProductDemand from '@/views/Sale/NewProductDemand.vue'  // Import the component
import PhoneSales from '@/views/Phone/PhoneSales.vue'  // Import the component
import { logout } from '../utils/auth'; // Logout fonksiyonunu içe aktar




const routes = [
  {
    path: '/',
    name: 'MainDashboard',
    component: MainDashboard // Ana sayfa bileşeni
  },
  {
    path: '/pDashboard',
    name: 'PhoneDashboard',
    component: PhoneDashboard // Ana sayfa bileşeni
  },
  
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: (to, from, next) => {
      logout();
      next({ name: 'UserLogin' }); // Giriş sayfasına yönlendir
    }
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin // Login görünümü
  },
  {
    path: '/register',
    name: 'UserRegister',
    component: UserRegister // Login görünümü
  },
  {
    path: '/users',
    name: 'UserList',
    component: UserList // Login görünümü
  },
  {
    path: '/sellers',
    name: 'SellerList',
    component: SellerList // Login görünümü
  },
  {
    path: '/customers',
    name: 'CustomerList',
    component: CustomerList // Login görünümü
  },
  {
    path: '/brands',
    name: 'BrandList',
    component: BrandList // Login görünümü
  },
  {
    path: '/colors',
    name: 'ColorList',
    component: ColorList // Login görünümü
  },

  {
    path: '/stocks',
    name: 'StockList',
    component: StockList // Login görünümü
  },
  {
    path: '/invoices',
    name: 'InvoiceList',
    component: InvoiceList // Login görünümü
  },{
    path: '/categories',
    name: 'CategoryList',
    component: CategoryList // Login görünümü
  },{
    path: '/phones',
    name: 'PhoneList',
    component: PhoneList // Login görünümü
  },{
    path: '/phone/create',
    name: 'PhoneCreate',
    component: PhoneCreate
  },{
    path: '/serialNumbers',
    name: 'SerialNumberList',
    component: SerialNumberList // Login görünümü
  },
  {
    path: '/transfers',
    name: 'TransferList',
    component: TransferList // Login görünümü
  },
  {
    path: '/sales',
    name: 'SaleList',
    component: SaleList // Login görünümü
  },
  {
    path: '/newProductDemand',
    name: 'NewProductDemand',
    component: NewProductDemand // Login görünümü
  },
  {
    path: '/phoneSales',
    name: 'PhoneSales',
    component: PhoneSales // Login görünümü
  },
  {
    path: '/technicalService',
    name: 'TechnicalServiceList',
    component: TechnicalServiceList // Login görünümü
  },
];
  

// createRouter fonksiyonu ile router'ı oluşturun
const router = createRouter({
  history: createWebHistory(), // Web geçmişi kullanarak router'ı oluşturun
  routes
});
router.beforeEach((to, from, next) => {
  const user = localStorage.getItem('user'); // Kullanıcı bilgilerini kontrol et

  if (!user && to.name !== 'UserLogin') {
    // Eğer kullanıcı yoksa ve yönlendirilmek istenen sayfa giriş sayfası değilse
    next({ name: 'UserLogin' }); // Giriş sayfasına yönlendir
  } else {
    next(); // Diğer route'lara devam et
  }
});

export default router; // Router'ı dışa aktarın
